var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.encabezados,"items":_vm.llamadas,"items-per-page":5,"multi-sort":true},on:{"click:row":_vm.llamadasPendientes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }